// 最高学历枚举（按文化程度从高到低）
// 编码与 mytgo / egoadmin / tgo.admin / xcx_tgo 保持严格一致
export default [
  { id: 1, name: '博士研究生' },
  { id: 2, name: '硕士研究生' },
  { id: 3, name: '本科' },
  { id: 4, name: '专科' },
  { id: 5, name: '中专/职高' },
  { id: 6, name: '高中' },
  { id: 7, name: '初中' }
]
